<template>
  <div class="popups">
      <div class="popups-img">
        <img :src="imgUrl" alt="">
        <div class="closeBtn" @click="closePopups">
          <img src="../../assets/popupClose.png" alt="">
        </div>
      </div>
  </div>
</template>

<script>
  export default {
    props: {
      imgUrl:{
        type:String,
        default:''
      },
      isShow:{
        type:Boolean,
        default:false
      }
    },
    data() {
      return {

      }
    },
    mounted() {

    },
    methods: {
      closePopups(){
        this.$emit('closePopups')
      }
    }
  }
</script>

<style scoped lang="less">
.popups{
  position: fixed;
  background-color: rgba(0,0,0,0.5);
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 999;
  padding: 0 14px;
  box-sizing: border-box;
  & .popups-img{
    width: 347px;
    height: 508px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    & img{
      width: 100%;
      height: 100%;
    }
  }
  & .closeBtn{
    width: 29px;
    height: 29px;
    position: absolute;
    top: -10px;
    right: -10px;
  & img{
    width: 100%;
    height: 100%;
  }
  }
}
</style>